import { EXTENSION_IDENTIFIER, WIDGET_VERSION } from "./serviceConstant";

export const dataCenterMap = {
  US: "https://www.zohoapis.com",
  EU: "https://www.zohoapis.eu",
  AU: "https://www.zohoapis.com.au",
  IN: "https://www.zohoapis.in",
  China: "https://www.zohoapis.com.cn",
  JP: "https://www.zohoapis.jp",
  SA: "https://www.zohoapis.sa",
  // Canada DC uses the zohocloud.ca accounts host but zohoapis.ca for APIs.
  CA: "https://www.zohoapis.ca",
};

export const accountUrlMap = {
  US: "https://accounts.zoho.com",
  AU: "https://accounts.zoho.com.au",
  EU: "https://accounts.zoho.eu",
  IN: "https://accounts.zoho.in",
  China: "https://accounts.zoho.com.cn",
  JP: "https://accounts.zoho.jp",
  SA: "https://accounts.zoho.sa",
  CA: "https://accounts.zohocloud.ca",
};

export const WIDGET_NAME = "Easy Shopify for Zoho CRM by Easy Pluginz";
export const WIDGET_URL = `https://widgets.${WIDGET_VERSION}.${EXTENSION_IDENTIFIER}.easy-pluginz.com/relatedlist`;
export const WIDGET_DESCRIPTION =
  "The related list widget allows you to view and manage Shopify data within Zoho CRM records.";
export const RELATEDLIST_WIDGET_TYPE = "RELATED_LIST";

// Sync Journey widget — a per-record related list rendering the chronological
// Shopify ↔ Zoho sync history from the Shopify_Logs module. Registered with
// Zoho (via the admin /data/zoho/crm/extwidgets endpoint) once CRM auth is
// confirmed. Values mirror the registration payload.
export const JOURNEY_WIDGET_NAME = "Easy Shopify Record Journey";
export const JOURNEY_WIDGET_URL = `https://widgets.${WIDGET_VERSION}.${EXTENSION_IDENTIFIER}.easy-pluginz.com/journey`;
export const JOURNEY_WIDGET_DESCRIPTION = "Shows linked Shopify data on the record";
export const JOURNEY_WIDGET_TYPE = "RELATED_LIST";
